export default __webpack_public_path__ + "static/media/Padron_CorticosOpen30.ac7830fb.jpg";